"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsonwebtoken_1 = require("jsonwebtoken");
var dexie_db_1 = __importDefault(require("./dexie-db"));
var SounditiApi_1 = __importDefault(require("../SounditiApi"));
var Auth_1 = __importDefault(require("../Auth"));
var defaults_1 = __importDefault(require("../defaults"));
var logger_1 = __importDefault(require("../utils/logger"));
var errors_1 = require("../utils/errors");
var utils_1 = require("../utils/utils");
var logger = logger_1.default('campaign-access');
/**
 * Provides access to the campaigns data to a web application
 * @class
 *
 * @param {string} [host = defaults.host] | the api host
 *
 * @category DataLayers
 *
 *
 * @todo autorenew token with api if token expired
 */
var CampaignAccess = /** @class */ (function () {
    /**
     *
     * @param {DataLayerConfiguration} options
     * @param {token} [options.token = ''] | An access token
     * @param {host} [options.hosts = defaults.host] | An access token
     *
     */
    function CampaignAccess(_a) {
        var _b = (_a === void 0 ? {} : _a).hosts, hosts = _b === void 0 ? defaults_1.default : _b;
        this._authRenewal = utils_1.tokenRenewal;
        this.auth = new Auth_1.default({ auth_host: hosts.auth_host });
        this.token = this.auth.getToken() || '';
        this.api = new SounditiApi_1.default({ token: this.token, hosts: hosts });
        this.table = 'campaigns';
    }
    /**
     * Get all campaign for the current user.
     *
     * It provides three operation modes:
     * <ul style="list-style: none;">
     * <li> - default : get updates from db and save changes to local.
     * <li> - local: don't call the db and returns only locally stored values.
     * <li> - refresh: deletes localDB and retrieves all campaigns from cloud storage.
     * </ul>
     *
     * @param {string} [mode = ''] defines the mode of operation:
     * @param {boolean} [renew = true] if true will try to renew accessToken on first PermissionError
     *
     * @throws {PermissionError} 403 responses or bad token
     *
     * @returns {Promise<CampaignItem[]>} a list of campaign items
     */
    CampaignAccess.prototype.getCampaigns = function (mode, renew) {
        if (mode === void 0) { mode = 'refresh'; }
        if (renew === void 0) { renew = true; }
        return __awaiter(this, void 0, void 0, function () {
            var update, refresh, error_1, payload, userID, campaigns, error_2, campaigns_1, json, error_3, error_4, updatedAt, res, new_campaignsItems, new_campaigns, old_campaigns_ids_1, new_campaigns_ids_1, to_update, to_add, to_maintain, error_5, campaigns_2, error_6;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        update = true;
                        refresh = false;
                        switch (mode) {
                            case 'local':
                                update = false;
                                refresh = false;
                                break;
                            case 'refresh':
                                update = true;
                                refresh = true;
                                break;
                            default:
                                update = true;
                                refresh = false;
                                break;
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 31, , 32]);
                        if (!refresh) return [3 /*break*/, 5];
                        logger.debug('getCampaigns deletes localDB');
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 4, , 5]);
                        return [4 /*yield*/, dexie_db_1.default.table(this.table).clear()];
                    case 3:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        error_1 = _a.sent();
                        console.log('db error: getCampaigns 1,', { error: error_1 });
                        return [3 /*break*/, 5];
                    case 5:
                        payload = jsonwebtoken_1.decode(this.token);
                        userID = payload.sub;
                        campaigns = [];
                        _a.label = 6;
                    case 6:
                        _a.trys.push([6, 8, , 9]);
                        return [4 /*yield*/, dexie_db_1.default.table(this.table).where('userId').equals(userID).toArray()];
                    case 7:
                        campaigns = _a.sent();
                        return [3 /*break*/, 9];
                    case 8:
                        error_2 = _a.sent();
                        console.log('db error: getCampaigns 2,', { error: error_2 });
                        return [3 /*break*/, 9];
                    case 9:
                        if (!update) {
                            logger.debug('getCampaigns from db: NO UPDATE');
                            return [2 /*return*/, campaigns];
                        }
                        if (!(campaigns.length === 0)) return [3 /*break*/, 19];
                        _a.label = 10;
                    case 10:
                        _a.trys.push([10, 17, , 18]);
                        return [4 /*yield*/, this.api.listCampaigns()];
                    case 11:
                        campaigns_1 = _a.sent();
                        return [4 /*yield*/, campaigns_1.json()];
                    case 12:
                        json = _a.sent();
                        logger.debug('getCampaigns from API:', json);
                        _a.label = 13;
                    case 13:
                        _a.trys.push([13, 15, , 16]);
                        return [4 /*yield*/, dexie_db_1.default.table(this.table).bulkPut(json.Items)];
                    case 14:
                        _a.sent();
                        return [3 /*break*/, 16];
                    case 15:
                        error_3 = _a.sent();
                        console.log('db error: getCampaigns 3,', { error: error_3 });
                        return [3 /*break*/, 16];
                    case 16: return [2 /*return*/, json.Items];
                    case 17:
                        error_4 = _a.sent();
                        throw new errors_1.DatabaseError('buldAdd error ');
                    case 18: return [3 /*break*/, 30];
                    case 19:
                        updatedAt = Math.max.apply(Math, campaigns.map(function (i) { return i.updatedAt; }));
                        return [4 /*yield*/, this.api.listCampaignsSinceUpdateAt(updatedAt + 1)];
                    case 20:
                        res = _a.sent();
                        if (!(res.status === 200)) return [3 /*break*/, 26];
                        return [4 /*yield*/, res.json()];
                    case 21:
                        new_campaignsItems = _a.sent();
                        new_campaigns = new_campaignsItems.Items;
                        old_campaigns_ids_1 = campaigns.map(function (c) { return c.campaignId; });
                        new_campaigns_ids_1 = new_campaigns.map(function (c) { return c.campaignId; });
                        to_update = new_campaigns.filter(function (c) { return old_campaigns_ids_1.includes(c.campaignId); });
                        to_add = new_campaigns.filter(function (c) { return !old_campaigns_ids_1.includes(c.campaignId); });
                        to_maintain = campaigns.filter(function (c) { return !new_campaigns_ids_1.includes(c.campaignId); });
                        _a.label = 22;
                    case 22:
                        _a.trys.push([22, 24, , 25]);
                        return [4 /*yield*/, dexie_db_1.default.table(this.table).bulkPut(new_campaigns)];
                    case 23:
                        _a.sent();
                        return [3 /*break*/, 25];
                    case 24:
                        error_5 = _a.sent();
                        console.log('db error: getCampaigns 4,', { error: error_5 });
                        return [3 /*break*/, 25];
                    case 25:
                        logger.debug('getCampaigns from db with updates from API:', [campaigns.length]);
                        return [2 /*return*/, __spreadArrays(to_update, to_add, to_maintain)];
                    case 26:
                        if (!(res.status === 403 && renew)) return [3 /*break*/, 29];
                        return [4 /*yield*/, this._authRenewal()];
                    case 27:
                        _a.sent();
                        return [4 /*yield*/, this.getCampaigns('', false)];
                    case 28:
                        campaigns_2 = _a.sent();
                        return [2 /*return*/, campaigns_2];
                    case 29: throw new errors_1.PermissionError('Invalid access token');
                    case 30: return [3 /*break*/, 32];
                    case 31:
                        error_6 = _a.sent();
                        logger.error('Error getting campaigns', { msg: error_6.message, name: error_6.name });
                        throw new errors_1.PermissionError(error_6.message);
                    case 32:
                        ;
                        return [2 /*return*/];
                }
            });
        });
    };
    ;
    /**
     * Return campaigns by id owned by the authenticated user.
     *
     * It provides three operation modes:
     * <ul style="list-style: none;">
     * <li> - default : get updates from db and save changes to local.
     * <li> - local: don't call the db and returns only locally stored values.
     * <li> - refresh: deletes localDB and retrieves all campaigns from cloud storage.
     * </ul>
     *
     * @param {string} campaignId The id of the campaign
     * @param {string} [mode = ''] defines the mode of operation:
     * @param {boolean} [renew = true] if true will try to renew accessToken on first PermissionError
     *
     * @returns {Promise<CampaignItem>} the campaign item
     *
     * @throws {PermissionError} 403 responses or bad token
     * @throws {NotFoundError} campaign item wasn't found
     */
    CampaignAccess.prototype.getCampaignbyID = function (campaignId, mode, renew) {
        if (mode === void 0) { mode = ""; }
        if (renew === void 0) { renew = true; }
        return __awaiter(this, void 0, void 0, function () {
            var update, refresh, error_7, campaign, error_8, res, campaign_1, error_9, campaign_2, e, error_10;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        update = true;
                        refresh = false;
                        switch (mode) {
                            case 'local':
                                update = false;
                                refresh = false;
                                break;
                            case 'refresh':
                                update = true;
                                refresh = true;
                                break;
                            default:
                                update = true;
                                refresh = false;
                                break;
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 24, , 25]);
                        if (!refresh) return [3 /*break*/, 5];
                        logger.debug('getCampaigns deletes localDB');
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 4, , 5]);
                        return [4 /*yield*/, dexie_db_1.default.table(this.table).where('campaignId').equals(campaignId).delete()];
                    case 3:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        error_7 = _a.sent();
                        console.log('db error: getCampaignbyID 1,', { error: error_7 });
                        return [3 /*break*/, 5];
                    case 5:
                        campaign = [];
                        _a.label = 6;
                    case 6:
                        _a.trys.push([6, 8, , 9]);
                        return [4 /*yield*/, dexie_db_1.default.table(this.table).where('campaignId').equals(campaignId).toArray()];
                    case 7:
                        campaign = _a.sent();
                        return [3 /*break*/, 9];
                    case 8:
                        error_8 = _a.sent();
                        console.log('db error: getCampaignbyID 2,', { error: error_8 });
                        return [3 /*break*/, 9];
                    case 9:
                        if (!update) {
                            logger.debug('getCampaignbyId from db: NO UPDATE');
                            return [2 /*return*/, campaign[0]];
                        }
                        if (!(campaign.length === 0)) return [3 /*break*/, 23];
                        return [4 /*yield*/, this.api.getCampaign(campaignId)];
                    case 10:
                        res = _a.sent();
                        if (!res.ok) return [3 /*break*/, 16];
                        return [4 /*yield*/, res.json()];
                    case 11:
                        campaign_1 = _a.sent();
                        logger.debug('getCampaignbyID from API', __assign({}, campaign_1));
                        _a.label = 12;
                    case 12:
                        _a.trys.push([12, 14, , 15]);
                        return [4 /*yield*/, dexie_db_1.default.table(this.table).add(campaign_1)];
                    case 13:
                        _a.sent();
                        return [3 /*break*/, 15];
                    case 14:
                        error_9 = _a.sent();
                        console.log('db error: getCampaignbyID 3,', { error: error_9 });
                        return [3 /*break*/, 15];
                    case 15: return [2 /*return*/, campaign_1];
                    case 16:
                        if (!(res.status === 403 && renew)) return [3 /*break*/, 19];
                        return [4 /*yield*/, this._authRenewal()];
                    case 17:
                        _a.sent();
                        return [4 /*yield*/, this.getCampaignbyID(campaignId, "", false)];
                    case 18:
                        campaign_2 = _a.sent();
                        return [2 /*return*/, campaign_2];
                    case 19:
                        if (!(res.status === 404)) return [3 /*break*/, 20];
                        logger.error('getCampaignbyID status 404');
                        throw new errors_1.NotFoundError('NotFound');
                    case 20:
                        if (!(res.status === 400)) return [3 /*break*/, 22];
                        return [4 /*yield*/, res.json()];
                    case 21:
                        e = _a.sent();
                        logger.error('getCampaignbyID status 400', { e: e });
                        throw new errors_1.NotFoundError(e.message);
                    case 22: throw new errors_1.PermissionError('Invalid access token');
                    case 23:
                        ;
                        logger.debug('getCampaignbyID from DB', __assign({}, campaign));
                        return [2 /*return*/, campaign[0]];
                    case 24:
                        error_10 = _a.sent();
                        logger.error('getCampaignbyID', { error: error_10 });
                        throw error_10;
                    case 25: return [2 /*return*/];
                }
            });
        });
    };
    ;
    /**
     * Creates a new campaign that will be owned by the account holder
     *
     * @param {object} data The data of the campaign
     * @param {boolean} [renew = true] If true will try to renew accessToken on first PermissionError
     *
     * @returns {Promise<CampaignItem>} New Campaign object
     *
     * @throws {PermissionError} 403 responses or bad token
     */
    CampaignAccess.prototype.createCampaign = function (data, featuresId, renew) {
        if (featuresId === void 0) { featuresId = undefined; }
        if (renew === void 0) { renew = true; }
        return __awaiter(this, void 0, void 0, function () {
            var res, json, error_11, campaign, error_12;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 12, , 13]);
                        return [4 /*yield*/, this.api.createCampaign(data, featuresId)];
                    case 1:
                        res = _a.sent();
                        if (!(res.status === 200)) return [3 /*break*/, 7];
                        return [4 /*yield*/, res.json()];
                    case 2:
                        json = _a.sent();
                        logger.debug('campaign created in DynamoDB', __assign({}, json));
                        _a.label = 3;
                    case 3:
                        _a.trys.push([3, 5, , 6]);
                        return [4 /*yield*/, dexie_db_1.default.table(this.table).put(json)];
                    case 4:
                        _a.sent();
                        return [3 /*break*/, 6];
                    case 5:
                        error_11 = _a.sent();
                        console.log('db error: createCampaign 1,', { error: error_11 });
                        return [3 /*break*/, 6];
                    case 6:
                        logger.debug('createCampaign', { json: json });
                        return [2 /*return*/, json];
                    case 7:
                        if (!(res.status === 403 && renew)) return [3 /*break*/, 10];
                        return [4 /*yield*/, this._authRenewal()];
                    case 8:
                        _a.sent();
                        return [4 /*yield*/, this.createCampaign(data, featuresId, false)];
                    case 9:
                        campaign = _a.sent();
                        return [2 /*return*/, campaign];
                    case 10: throw new errors_1.PermissionError('Invalid access token');
                    case 11: return [3 /*break*/, 13];
                    case 12:
                        error_12 = _a.sent();
                        logger.error('Error creating campaign', { msg: error_12.message, name: error_12.name });
                        throw new errors_1.PermissionError(error_12.message);
                    case 13: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Warning: replaces the entire data of the campaign
     *
     * Updates a campaign owned by the token holder
     * provided the entire data object and the campaignID
     *
     * @param {string} campaignId The campaign id
     * @param {object} data The campaign data object
     * @param {boolean} [renew = true] If true will try to renew accessToken on first PermissionError
     *
     * @return {Promise<CampaignItem>} The updated campaign
     *
     * @throws {UpdateError} When user tries to updated a paid or a public campaign
     * @throws {PermissionError} 403 responses or bad token
     */
    CampaignAccess.prototype.updateCampaign = function (campaignId, data, createCampaignDataVersion, renew) {
        if (createCampaignDataVersion === void 0) { createCampaignDataVersion = true; }
        if (renew === void 0) { renew = true; }
        return __awaiter(this, void 0, void 0, function () {
            var res, campaign, error_13, campaign, e, error_14;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 14, , 15]);
                        return [4 /*yield*/, this.api.updateCampaign(campaignId, { data: data }, createCampaignDataVersion)];
                    case 1:
                        res = _a.sent();
                        if (!(res.status === 200)) return [3 /*break*/, 7];
                        return [4 /*yield*/, res.json()];
                    case 2:
                        campaign = _a.sent();
                        _a.label = 3;
                    case 3:
                        _a.trys.push([3, 5, , 6]);
                        return [4 /*yield*/, dexie_db_1.default.table(this.table).put(campaign)];
                    case 4:
                        _a.sent();
                        return [3 /*break*/, 6];
                    case 5:
                        error_13 = _a.sent();
                        console.log('db error: updateCampaign 1,', { error: error_13 });
                        return [3 /*break*/, 6];
                    case 6:
                        logger.debug('updateCampaign: campaign updated', __assign({}, campaign));
                        return [2 /*return*/, campaign];
                    case 7:
                        if (!(res.status === 403 && renew)) return [3 /*break*/, 10];
                        return [4 /*yield*/, this._authRenewal()];
                    case 8:
                        _a.sent();
                        return [4 /*yield*/, this.updateCampaign(campaignId, data, createCampaignDataVersion, false)];
                    case 9:
                        campaign = _a.sent();
                        return [2 /*return*/, campaign];
                    case 10:
                        if (!(res.status === 400)) return [3 /*break*/, 12];
                        return [4 /*yield*/, res.json()];
                    case 11:
                        e = _a.sent();
                        logger.debug('res status 400', { e: e });
                        throw new errors_1.UpdateError(e.message);
                    case 12: throw new errors_1.PermissionError('Invalid access token');
                    case 13: return [3 /*break*/, 15];
                    case 14:
                        error_14 = _a.sent();
                        logger.error('Error updating campaign', { msg: error_14.message, name: error_14.name });
                        throw error_14;
                    case 15: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Deletes a campaign owned by the token holder
     *
     * @param {string} campaignId the campaignID
     * @param {boolean} [renew = true] if true will try to renew accessToken on first PermissionError
     *
     * @throws {PermissionError} 403 responses or bad token
     *
     * @returns {string} Returns '' if the campaign was deleted
     */
    CampaignAccess.prototype.deleteCampaign = function (campaignId, renew) {
        if (renew === void 0) { renew = true; }
        return __awaiter(this, void 0, void 0, function () {
            var res, error_15, error_16;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 11, , 12]);
                        return [4 /*yield*/, this.api.deleteCampaign(campaignId)];
                    case 1:
                        res = _a.sent();
                        logger.debug(res);
                        if (!(res.status === 200)) return [3 /*break*/, 6];
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 4, , 5]);
                        return [4 /*yield*/, dexie_db_1.default.table(this.table).delete(campaignId)];
                    case 3:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        error_15 = _a.sent();
                        throw error_15;
                    case 5:
                        logger.debug('deleteCampaign', { campaignId: campaignId });
                        return [3 /*break*/, 10];
                    case 6:
                        if (!(res.status === 403 && renew)) return [3 /*break*/, 9];
                        return [4 /*yield*/, this._authRenewal()];
                    case 7:
                        _a.sent();
                        return [4 /*yield*/, this.deleteCampaign(campaignId, false)];
                    case 8:
                        _a.sent();
                        return [3 /*break*/, 10];
                    case 9: throw new errors_1.PermissionError('Invalid access token');
                    case 10: return [3 /*break*/, 12];
                    case 11:
                        error_16 = _a.sent();
                        logger.error('deleteCampaign', __assign({}, error_16));
                        logger.error('Error deleting campaign', { msg: error_16.message, name: error_16.name });
                        throw new errors_1.PermissionError(error_16.message);
                    case 12: return [2 /*return*/, ''];
                }
            });
        });
    };
    /**
     * Toogles a campaign status between draft|preview and
     * generates or updates 'preview_password' and 'preview_token'
     * for preview and paid campaigns
     *
     * @param {string} campaignId The campaignID
     * @param {boolean} [renew = true] If true will try to renew accessToken on first PermissionError
     *
     * @return {Promise<CampaignItem>} the toogled campaign
     *
     * @throws {PermissionError} 403 responses or bad token
     */
    CampaignAccess.prototype.changeStatus = function (campaignId, renew) {
        if (renew === void 0) { renew = true; }
        return __awaiter(this, void 0, void 0, function () {
            var res, campaign, error_17, campaign, error_18;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 12, , 13]);
                        return [4 /*yield*/, this.api.previewCampaign(campaignId)];
                    case 1:
                        res = _a.sent();
                        if (!(res.status === 200)) return [3 /*break*/, 7];
                        return [4 /*yield*/, res.json()];
                    case 2:
                        campaign = _a.sent();
                        _a.label = 3;
                    case 3:
                        _a.trys.push([3, 5, , 6]);
                        return [4 /*yield*/, dexie_db_1.default.table(this.table).put(campaign)];
                    case 4:
                        _a.sent();
                        return [3 /*break*/, 6];
                    case 5:
                        error_17 = _a.sent();
                        console.log('db error: changeStatus 1,', { error: error_17 });
                        return [3 /*break*/, 6];
                    case 6:
                        logger.debug('changeStatus: campaign updated', __assign({}, campaign));
                        return [2 /*return*/, campaign];
                    case 7:
                        if (!(res.status === 403 && renew)) return [3 /*break*/, 10];
                        return [4 /*yield*/, this._authRenewal()];
                    case 8:
                        _a.sent();
                        return [4 /*yield*/, this.changeStatus(campaignId, false)];
                    case 9:
                        campaign = _a.sent();
                        return [2 /*return*/, campaign];
                    case 10: throw new errors_1.PermissionError('Invalid access token');
                    case 11: return [3 /*break*/, 13];
                    case 12:
                        error_18 = _a.sent();
                        logger.error('Error updating campaign', { msg: error_18.message, name: error_18.name });
                        throw new errors_1.PermissionError(error_18.message);
                    case 13: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Clones a campaign
     *
     * @param {string} campaignId the origin campaignID
     * @param {boolean} [renew = true] if true will try to renew accessToken on first PermissionError
     *
     * @return {Promise<CampaignItem>} the new campaign
     *
     * @throws {PermissionError} 403 responses or bad token
     */
    CampaignAccess.prototype.cloneCampaign = function (campaignId, renew) {
        if (renew === void 0) { renew = true; }
        return __awaiter(this, void 0, void 0, function () {
            var res, campaign, error_19, campaign, error_20;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 12, , 13]);
                        return [4 /*yield*/, this.api.cloneCampaign(campaignId)];
                    case 1:
                        res = _a.sent();
                        if (!(res.status === 200)) return [3 /*break*/, 7];
                        return [4 /*yield*/, res.json()];
                    case 2:
                        campaign = _a.sent();
                        _a.label = 3;
                    case 3:
                        _a.trys.push([3, 5, , 6]);
                        return [4 /*yield*/, dexie_db_1.default.table(this.table).put(campaign)];
                    case 4:
                        _a.sent();
                        return [3 /*break*/, 6];
                    case 5:
                        error_19 = _a.sent();
                        console.log('db error: cloneCampaign 1,', { error: error_19 });
                        return [3 /*break*/, 6];
                    case 6:
                        logger.debug('cloneCampaign: campaign cloned', __assign({}, campaign));
                        return [2 /*return*/, campaign];
                    case 7:
                        if (!(res.status === 403 && renew)) return [3 /*break*/, 10];
                        return [4 /*yield*/, this._authRenewal()];
                    case 8:
                        _a.sent();
                        return [4 /*yield*/, this.cloneCampaign(campaignId, false)];
                    case 9:
                        campaign = _a.sent();
                        return [2 /*return*/, campaign];
                    case 10: throw new errors_1.PermissionError('Invalid access token');
                    case 11: return [3 /*break*/, 13];
                    case 12:
                        error_20 = _a.sent();
                        logger.error('Error updating campaign', { msg: error_20.message, name: error_20.name });
                        throw new errors_1.PermissionError(error_20.message);
                    case 13: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Creates a new link related with a campaign
     *
     * @param {CreateLinkRequest} link The link request object with the campaignId, the alias, and if it is link and/or active
     * @param {boolean} [withStatistics = false] If true will return the link statistics
     * @param {boolean} [renew = true] If true will try to renew accessToken on first PermissionError
     *
     * @returns {Promise<Link>} New Link object
     *
     * @throws {PermissionError} 403 Responses or bad token
     * @throws {Error} 40X Generic error
     */
    CampaignAccess.prototype.createLink = function (link, withStatistics, renew) {
        if (withStatistics === void 0) { withStatistics = false; }
        if (renew === void 0) { renew = true; }
        return __awaiter(this, void 0, void 0, function () {
            var res, json, res_1, error_21;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 8, , 9]);
                        return [4 /*yield*/, this.api.createLink(link, withStatistics)];
                    case 1:
                        res = _a.sent();
                        if (!(res.status === 200)) return [3 /*break*/, 3];
                        return [4 /*yield*/, res.json()];
                    case 2:
                        json = _a.sent();
                        logger.debug('link created in DynamoDB', __assign({}, json));
                        return [2 /*return*/, json];
                    case 3:
                        if (!(res.status === 403 && renew)) return [3 /*break*/, 6];
                        return [4 /*yield*/, this._authRenewal()];
                    case 4:
                        _a.sent();
                        return [4 /*yield*/, this.createLink(link, withStatistics, false)];
                    case 5:
                        res_1 = _a.sent();
                        return [2 /*return*/, res_1];
                    case 6:
                        if (res.status === 402) {
                            throw new Error('The maximum number of tests has been reached');
                        }
                        else {
                            throw new errors_1.PermissionError('Invalid access token');
                        }
                        _a.label = 7;
                    case 7: return [3 /*break*/, 9];
                    case 8:
                        error_21 = _a.sent();
                        logger.error('Error creating link', { msg: error_21.message, name: error_21.name });
                        throw new Error(error_21);
                    case 9: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Gets all the links of a campaign
     *
     * @param {string} campaignId The campaign identifier
     * @param {boolean} [renew = true] If true will try to renew accessToken on first PermissionError
     *
     * @returns {Promise<Link[]>} The links list of a campaign
     *
     * @throws {PermissionError} 403 responses or bad token
     */
    CampaignAccess.prototype.getLinks = function (campaignId, withStatistics, renew) {
        if (withStatistics === void 0) { withStatistics = true; }
        if (renew === void 0) { renew = true; }
        return __awaiter(this, void 0, void 0, function () {
            var res, links, links, e, error_22;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 11, , 12]);
                        return [4 /*yield*/, this.api.getLinks(campaignId, withStatistics)];
                    case 1:
                        res = _a.sent();
                        if (!res.ok) return [3 /*break*/, 3];
                        return [4 /*yield*/, res.json()];
                    case 2:
                        links = _a.sent();
                        logger.debug('getLinks from API', __assign({}, links));
                        return [2 /*return*/, links];
                    case 3:
                        if (!(res.status === 403 && renew)) return [3 /*break*/, 6];
                        return [4 /*yield*/, this._authRenewal()];
                    case 4:
                        _a.sent();
                        return [4 /*yield*/, this.getLinks(campaignId, withStatistics, false)];
                    case 5:
                        links = _a.sent();
                        return [2 /*return*/, links];
                    case 6:
                        if (!(res.status === 404)) return [3 /*break*/, 7];
                        logger.error('getLinks status 404');
                        throw new errors_1.NotFoundError('NotFound');
                    case 7:
                        if (!(res.status === 400)) return [3 /*break*/, 9];
                        return [4 /*yield*/, res.json()];
                    case 8:
                        e = _a.sent();
                        logger.error('getLinks status 400', { e: e });
                        throw new errors_1.NotFoundError(e.message);
                    case 9: throw new errors_1.PermissionError('Invalid access token');
                    case 10: return [3 /*break*/, 12];
                    case 11:
                        error_22 = _a.sent();
                        logger.error('Error getLinks', { msg: error_22.message, name: error_22.name });
                        throw new Error(error_22.message);
                    case 12: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Updates a link
     *
     * @param {Link} link The link object with the new changes
     * @param {boolean} [renew = true] If true will try to renew accessToken on first PermissionError
     *
     * @return {Promise<Link>} The updated link object
     *
     * @throws {PermissionError} 403 responses or bad token
     */
    CampaignAccess.prototype.updateLink = function (link, withStatistics, renew) {
        if (withStatistics === void 0) { withStatistics = false; }
        if (renew === void 0) { renew = true; }
        return __awaiter(this, void 0, void 0, function () {
            var res, updatedLink, updatedLink, error_23;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 8, , 9]);
                        return [4 /*yield*/, this.api.updateLink(link, withStatistics)];
                    case 1:
                        res = _a.sent();
                        if (!(res.status === 200)) return [3 /*break*/, 3];
                        return [4 /*yield*/, res.json()];
                    case 2:
                        updatedLink = _a.sent();
                        logger.debug('link updated', __assign({}, updatedLink));
                        return [2 /*return*/, updatedLink];
                    case 3:
                        if (!(res.status === 403 && renew)) return [3 /*break*/, 6];
                        return [4 /*yield*/, this._authRenewal()];
                    case 4:
                        _a.sent();
                        return [4 /*yield*/, this.updateLink(link, withStatistics, false)];
                    case 5:
                        updatedLink = _a.sent();
                        return [2 /*return*/, updatedLink];
                    case 6: throw new errors_1.PermissionError('Invalid access token');
                    case 7: return [3 /*break*/, 9];
                    case 8:
                        error_23 = _a.sent();
                        logger.error('Error updateLink', { msg: error_23.message, name: error_23.name });
                        throw new Error(error_23.message);
                    case 9: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Gets a link object giving the link url
     *
     * @param {string} linkUrl The link url
     * @param {boolean} [renew = true] If true will try to renew accessToken on first PermissionError
     *
     * @returns {Promise<Link>} The links list of a campaign
     *
     * @throws {Error} 403 responses or bad token
     */
    CampaignAccess.prototype.getLinkByUrl = function (linkUrl, renew) {
        if (renew === void 0) { renew = true; }
        return __awaiter(this, void 0, void 0, function () {
            var res, link, link, e, error_24;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 11, , 12]);
                        return [4 /*yield*/, this.api.getLinkByUrl(linkUrl)];
                    case 1:
                        res = _a.sent();
                        if (!res.ok) return [3 /*break*/, 3];
                        return [4 /*yield*/, res.json()];
                    case 2:
                        link = _a.sent();
                        logger.debug('getLinkByUrl from API', __assign({}, link));
                        return [2 /*return*/, link];
                    case 3:
                        if (!(res.status === 403 && renew)) return [3 /*break*/, 6];
                        return [4 /*yield*/, this._authRenewal()];
                    case 4:
                        _a.sent();
                        return [4 /*yield*/, this.getLinkByUrl(linkUrl, false)];
                    case 5:
                        link = _a.sent();
                        return [2 /*return*/, link];
                    case 6:
                        if (!(res.status === 404)) return [3 /*break*/, 7];
                        logger.error('getLinkByUrl status 404');
                        throw new errors_1.NotFoundError('NotFound');
                    case 7:
                        if (!(res.status === 400)) return [3 /*break*/, 9];
                        return [4 /*yield*/, res.json()];
                    case 8:
                        e = _a.sent();
                        logger.error('getLinkByUrl status 400', { e: e });
                        throw new errors_1.NotFoundError(e.message);
                    case 9: throw new errors_1.PermissionError('Invalid access token');
                    case 10: return [3 /*break*/, 12];
                    case 11:
                        error_24 = _a.sent();
                        logger.error('Error getLinkByUrl', { msg: error_24.message, name: error_24.name });
                        throw new Error(error_24.message);
                    case 12: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Gets a link object giving the link url
     *
     * @param {string} linkUrl The link url
     * @param {boolean} [renew = true] If true will try to renew accessToken on first PermissionError
     *
     * @returns {Promise<boolean>} The links list of a campaign
     *
     * @throws {PermissionError} 403 responses or bad token
     */
    CampaignAccess.prototype.checkAvailableUrl = function (linkUrl, renew) {
        if (renew === void 0) { renew = true; }
        return __awaiter(this, void 0, void 0, function () {
            var res, isAvailable, isAvailable, e, error_25;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 11, , 12]);
                        return [4 /*yield*/, this.api.checkAvailableUrl(linkUrl)];
                    case 1:
                        res = _a.sent();
                        if (!res.ok) return [3 /*break*/, 3];
                        return [4 /*yield*/, res.json()];
                    case 2:
                        isAvailable = _a.sent();
                        logger.debug('checkAvailableUrl from API', __assign({}, isAvailable));
                        return [2 /*return*/, isAvailable];
                    case 3:
                        if (!(res.status === 403 && renew)) return [3 /*break*/, 6];
                        return [4 /*yield*/, this._authRenewal()];
                    case 4:
                        _a.sent();
                        return [4 /*yield*/, this.checkAvailableUrl(linkUrl, false)];
                    case 5:
                        isAvailable = _a.sent();
                        return [2 /*return*/, isAvailable];
                    case 6:
                        if (!(res.status === 404)) return [3 /*break*/, 7];
                        logger.error('checkAvailableUrl status 404');
                        throw new errors_1.NotFoundError('NotFound');
                    case 7:
                        if (!(res.status === 400)) return [3 /*break*/, 9];
                        return [4 /*yield*/, res.json()];
                    case 8:
                        e = _a.sent();
                        logger.error('checkAvailableUrl status 400', { e: e });
                        throw new errors_1.NotFoundError(e.message);
                    case 9: throw new errors_1.PermissionError('Invalid access token');
                    case 10: return [3 /*break*/, 12];
                    case 11:
                        error_25 = _a.sent();
                        logger.error('Error checkAvailableUrl', { msg: error_25.message, name: error_25.name });
                        throw new Error(error_25.message);
                    case 12: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Deletes a link
     *
     * @param {Link} link The link object with the new changes
     * @param {boolean} [renew = true] if true will try to renew accessToken on first PermissionError
     *
     * @throws {PermissionError} 403 responses or bad token
     *
     * @returns {Promise<Link>} The deleted link object
     */
    CampaignAccess.prototype.deleteLink = function (link, renew) {
        if (renew === void 0) { renew = true; }
        return __awaiter(this, void 0, void 0, function () {
            var res, link_1, error_26;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 8, , 9]);
                        return [4 /*yield*/, this.api.deleteLink(link)];
                    case 1:
                        res = _a.sent();
                        logger.debug(res);
                        if (!(res.status === 200)) return [3 /*break*/, 3];
                        return [4 /*yield*/, res.json()];
                    case 2:
                        link_1 = _a.sent();
                        logger.debug('deleteLink', { link: link_1 });
                        return [2 /*return*/, link_1];
                    case 3:
                        if (!(res.status === 403 && renew)) return [3 /*break*/, 6];
                        return [4 /*yield*/, this._authRenewal()];
                    case 4:
                        _a.sent();
                        return [4 /*yield*/, this.deleteLink(link, false)];
                    case 5:
                        _a.sent();
                        return [3 /*break*/, 7];
                    case 6: throw new errors_1.PermissionError('Invalid access token');
                    case 7: return [3 /*break*/, 9];
                    case 8:
                        error_26 = _a.sent();
                        logger.error('Error deleteLink', { msg: error_26.message, name: error_26.name });
                        throw new Error(error_26.message);
                    case 9: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Gets all the dataversions of a campaign
     *
     * @param {string} campaignId The campaign identifier
     * @param {number} [fromCreatedAt = 0] The timestamp from when the data were created
     * @param {number} [fromNumberOfVersion = 1] The minimum number of version to be returned
     * @param {number} [toNumberOfVersion = 50] The maximum number of version to be returned
     * @param {boolean} [renew = true] If true will try to renew accessToken on first PermissionError
     *
     * @returns {Promise<CampaignVersion[]>} The CampaignVersions of a campaign
     *
     * @throws {PermissionError} 403 responses or bad token
     */
    CampaignAccess.prototype.getCampaignVersions = function (campaignId, numberOfPage, offset, fromCreatedAt, renew) {
        if (numberOfPage === void 0) { numberOfPage = 1; }
        if (offset === void 0) { offset = 50; }
        if (fromCreatedAt === void 0) { fromCreatedAt = 0; }
        if (renew === void 0) { renew = true; }
        return __awaiter(this, void 0, void 0, function () {
            var res, campaignVersions, campaignVersions, e, error_27;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 11, , 12]);
                        return [4 /*yield*/, this.api.getCampaignVersions(campaignId, numberOfPage, offset, fromCreatedAt)];
                    case 1:
                        res = _a.sent();
                        if (!res.ok) return [3 /*break*/, 3];
                        return [4 /*yield*/, res.json()];
                    case 2:
                        campaignVersions = _a.sent();
                        logger.debug('getCampaignVersions from API', __assign({}, campaignVersions));
                        return [2 /*return*/, campaignVersions];
                    case 3:
                        if (!(res.status === 403 && renew)) return [3 /*break*/, 6];
                        return [4 /*yield*/, this._authRenewal()];
                    case 4:
                        _a.sent();
                        return [4 /*yield*/, this.getCampaignVersions(campaignId, numberOfPage, offset, fromCreatedAt, false)];
                    case 5:
                        campaignVersions = _a.sent();
                        return [2 /*return*/, campaignVersions];
                    case 6:
                        if (!(res.status === 404)) return [3 /*break*/, 7];
                        logger.error('getCampaignVersions status 404');
                        throw new errors_1.NotFoundError('NotFound');
                    case 7:
                        if (!(res.status === 400)) return [3 /*break*/, 9];
                        return [4 /*yield*/, res.json()];
                    case 8:
                        e = _a.sent();
                        logger.error('getCampaignVersions status 400', { e: e });
                        throw new errors_1.NotFoundError(e.message);
                    case 9: throw new errors_1.PermissionError('Invalid access token');
                    case 10: return [3 /*break*/, 12];
                    case 11:
                        error_27 = _a.sent();
                        logger.error('Error getCampaignVersions', { msg: error_27.message, name: error_27.name });
                        throw new Error(error_27.message);
                    case 12: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Updates a campaign version
     *
     * @param {string} campaignId The campaign identifier
     * @param {number} createdAt The timestamp when the version was created
     * @param {string} name The name of the version
     *
     * @returns {Promise<CampaignVersion>} The CampaignVersion  object
     */
    CampaignAccess.prototype.updateCampaignVersion = function (campaignId, createdAt, name, renew) {
        if (renew === void 0) { renew = true; }
        return __awaiter(this, void 0, void 0, function () {
            var res, updatedCampaignVersion, updatedCampaignVersion, error_28;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 8, , 9]);
                        return [4 /*yield*/, this.api.updateCampaignVersion(campaignId, createdAt, name)];
                    case 1:
                        res = _a.sent();
                        if (!(res.status === 200)) return [3 /*break*/, 3];
                        return [4 /*yield*/, res.json()];
                    case 2:
                        updatedCampaignVersion = _a.sent();
                        logger.debug('CampaignVersion updated', __assign({}, updatedCampaignVersion));
                        return [2 /*return*/, updatedCampaignVersion];
                    case 3:
                        if (!(res.status === 403 && renew)) return [3 /*break*/, 6];
                        return [4 /*yield*/, this._authRenewal()];
                    case 4:
                        _a.sent();
                        return [4 /*yield*/, this.updateCampaignVersion(campaignId, createdAt, name, false)];
                    case 5:
                        updatedCampaignVersion = _a.sent();
                        return [2 /*return*/, updatedCampaignVersion];
                    case 6: throw new errors_1.PermissionError('Invalid access token');
                    case 7: return [3 /*break*/, 9];
                    case 8:
                        error_28 = _a.sent();
                        logger.error('Error updateCampaignVersion', { msg: error_28.message, name: error_28.name });
                        throw new Error(error_28.message);
                    case 9: return [2 /*return*/];
                }
            });
        });
    };
    ;
    /**
     * Creates testers related with a campaign
     *
     * @param {string} campaignId The campaign identifier
     * @param {string[]} emails A list with the emails of the testers
     *
     * @returns {Promise<TesterItem[]>} The module with choose tech metrics
     *
     * @throws {PermissionError} Auth token not valid
     */
    CampaignAccess.prototype.addTestersToCampaign = function (emails, campaignId, renew) {
        if (renew === void 0) { renew = true; }
        return __awaiter(this, void 0, void 0, function () {
            var res, testers, testers, error_29;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 8, , 9]);
                        return [4 /*yield*/, this.api.addTestersToCampaign(emails, campaignId)];
                    case 1:
                        res = _a.sent();
                        if (!(res.status === 200)) return [3 /*break*/, 3];
                        return [4 /*yield*/, res.json()];
                    case 2:
                        testers = _a.sent();
                        logger.debug('addTestersToCampaign updated', __assign({}, testers));
                        return [2 /*return*/, testers];
                    case 3:
                        if (!(res.status === 403 && renew)) return [3 /*break*/, 6];
                        return [4 /*yield*/, this._authRenewal()];
                    case 4:
                        _a.sent();
                        return [4 /*yield*/, this.addTestersToCampaign(emails, campaignId, false)];
                    case 5:
                        testers = _a.sent();
                        return [2 /*return*/, testers];
                    case 6: throw new errors_1.PermissionError('Invalid access token');
                    case 7: return [3 /*break*/, 9];
                    case 8:
                        error_29 = _a.sent();
                        logger.error('Error addTestersToCampaign', { msg: error_29.message, name: error_29.name });
                        throw new Error(error_29.message);
                    case 9: return [2 /*return*/];
                }
            });
        });
    };
    ;
    /**
     * Generates tester watermark and send an invitation email
     *
     * @param {string} campaignId The campaign identifier
     * @param {string[]} emails A list with the emails of the testers
     *
     * @returns {Promise<TesterItem[]>} The module with choose tech metrics
     *
     * @throws {PermissionError} Auth token not valid
     */
    CampaignAccess.prototype.inviteTestersToCampaign = function (emails, campaignId, renew) {
        if (renew === void 0) { renew = true; }
        return __awaiter(this, void 0, void 0, function () {
            var res, testers, testers, error_30;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 8, , 9]);
                        return [4 /*yield*/, this.api.inviteTestersToCampaign(emails, campaignId)];
                    case 1:
                        res = _a.sent();
                        if (!(res.status === 200)) return [3 /*break*/, 3];
                        return [4 /*yield*/, res.json()];
                    case 2:
                        testers = _a.sent();
                        logger.debug('inviteTestersToCampaign updated', __assign({}, testers));
                        return [2 /*return*/, testers];
                    case 3:
                        if (!(res.status === 403 && renew)) return [3 /*break*/, 6];
                        return [4 /*yield*/, this._authRenewal()];
                    case 4:
                        _a.sent();
                        return [4 /*yield*/, this.inviteTestersToCampaign(emails, campaignId, false)];
                    case 5:
                        testers = _a.sent();
                        return [2 /*return*/, testers];
                    case 6: throw new errors_1.PermissionError('Invalid access token');
                    case 7: return [3 /*break*/, 9];
                    case 8:
                        error_30 = _a.sent();
                        logger.error('Error inviteTestersToCampaign', { msg: error_30.message, name: error_30.name });
                        throw new Error(error_30.message);
                    case 9: return [2 /*return*/];
                }
            });
        });
    };
    ;
    /**
     * Resend the invitation email
     *
     * @param {string} campaignId The campaign identifier
     * @param {string[]} emails A list with the emails of the testers
     *
     * @returns {Promise<TesterItem[]>} The module with choose tech metrics
     *
     * @throws {PermissionError} Auth token not valid
     */
    CampaignAccess.prototype.resendTestersInvitation = function (emails, campaignId, renew) {
        if (renew === void 0) { renew = true; }
        return __awaiter(this, void 0, void 0, function () {
            var res, testers, testers, error_31;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 8, , 9]);
                        return [4 /*yield*/, this.api.resendTestersInvitation(emails, campaignId)];
                    case 1:
                        res = _a.sent();
                        if (!(res.status === 200)) return [3 /*break*/, 3];
                        return [4 /*yield*/, res.json()];
                    case 2:
                        testers = _a.sent();
                        logger.debug('resendTestersInvitation updated', __assign({}, testers));
                        return [2 /*return*/, testers];
                    case 3:
                        if (!(res.status === 403 && renew)) return [3 /*break*/, 6];
                        return [4 /*yield*/, this._authRenewal()];
                    case 4:
                        _a.sent();
                        return [4 /*yield*/, this.resendTestersInvitation(emails, campaignId, false)];
                    case 5:
                        testers = _a.sent();
                        return [2 /*return*/, testers];
                    case 6: throw new errors_1.PermissionError('Invalid access token');
                    case 7: return [3 /*break*/, 9];
                    case 8:
                        error_31 = _a.sent();
                        logger.error('Error resendTestersInvitation', { msg: error_31.message, name: error_31.name });
                        throw new Error(error_31.message);
                    case 9: return [2 /*return*/];
                }
            });
        });
    };
    ;
    /**
     * Enable or disable a group of testers
     *
     * @param {string} campaignId The campaign identifier
     * @param {string[]} emails A list with the emails of the testers
     * @param {boolean} enable true if the testes ahs to be enabled
     *
     * @returns {Promise<TesterItem[]>} The module with choose tech metrics
     *
     * @throws {PermissionError} Auth token not valid
     */
    CampaignAccess.prototype.enableDisableTesters = function (emails, campaignId, enable, renew) {
        if (renew === void 0) { renew = true; }
        return __awaiter(this, void 0, void 0, function () {
            var res, testers, testers, error_32;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 8, , 9]);
                        return [4 /*yield*/, this.api.enableDisableTesters(emails, campaignId, enable)];
                    case 1:
                        res = _a.sent();
                        if (!(res.status === 200)) return [3 /*break*/, 3];
                        return [4 /*yield*/, res.json()];
                    case 2:
                        testers = _a.sent();
                        logger.debug('enableDisableTesters updated', __assign({}, testers));
                        return [2 /*return*/, testers];
                    case 3:
                        if (!(res.status === 403 && renew)) return [3 /*break*/, 6];
                        return [4 /*yield*/, this._authRenewal()];
                    case 4:
                        _a.sent();
                        return [4 /*yield*/, this.enableDisableTesters(emails, campaignId, enable, false)];
                    case 5:
                        testers = _a.sent();
                        return [2 /*return*/, testers];
                    case 6: throw new errors_1.PermissionError('Invalid access token');
                    case 7: return [3 /*break*/, 9];
                    case 8:
                        error_32 = _a.sent();
                        logger.error('Error enableDisableTesters', { msg: error_32.message, name: error_32.name });
                        throw new Error(error_32.message);
                    case 9: return [2 /*return*/];
                }
            });
        });
    };
    ;
    /**
     * Deletes a group of testers and their links
     *
     * @param {string} campaignId The campaign identifier
     * @param {string[]} emails A list with the emails of the testers
     *
     * @returns {Promise<TesterItem[]>} The module with choose tech metrics
     *
     * @throws {PermissionError} Auth token not valid
     */
    CampaignAccess.prototype.deleteTesters = function (emails, campaignId, renew) {
        if (renew === void 0) { renew = true; }
        return __awaiter(this, void 0, void 0, function () {
            var res, testers, testers, error_33;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 8, , 9]);
                        return [4 /*yield*/, this.api.deleteTesters(emails, campaignId)];
                    case 1:
                        res = _a.sent();
                        if (!(res.status === 200)) return [3 /*break*/, 3];
                        return [4 /*yield*/, res.json()];
                    case 2:
                        testers = _a.sent();
                        logger.debug('deleteTesters updated', __assign({}, testers));
                        return [2 /*return*/, testers];
                    case 3:
                        if (!(res.status === 403 && renew)) return [3 /*break*/, 6];
                        return [4 /*yield*/, this._authRenewal()];
                    case 4:
                        _a.sent();
                        return [4 /*yield*/, this.deleteTesters(emails, campaignId, false)];
                    case 5:
                        testers = _a.sent();
                        return [2 /*return*/, testers];
                    case 6: throw new errors_1.PermissionError('Invalid access token');
                    case 7: return [3 /*break*/, 9];
                    case 8:
                        error_33 = _a.sent();
                        logger.error('Error deleteTesters', { msg: error_33.message, name: error_33.name });
                        throw new Error(error_33.message);
                    case 9: return [2 /*return*/];
                }
            });
        });
    };
    ;
    /**
     * Reactivates a tester froma film campaign
     *
     * @param {string} campaignId The campaign identifier
     * @param {string} emails The email of the tester to reactivate
     *
     * @returns {Promise<TesterItem>} The tester item updated
     *
     * @throws {PermissionError} Auth token not valid
     */
    CampaignAccess.prototype.reactivateFilmTester = function (email, campaignId, renew) {
        if (renew === void 0) { renew = true; }
        return __awaiter(this, void 0, void 0, function () {
            var res, tester, tester, error_34;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 8, , 9]);
                        return [4 /*yield*/, this.api.reactivateFilmTester(email, campaignId)];
                    case 1:
                        res = _a.sent();
                        if (!(res.status === 200)) return [3 /*break*/, 3];
                        return [4 /*yield*/, res.json()];
                    case 2:
                        tester = _a.sent();
                        logger.debug('reactivateFilmTester updated', __assign({}, tester));
                        return [2 /*return*/, tester];
                    case 3:
                        if (!(res.status === 403 && renew)) return [3 /*break*/, 6];
                        return [4 /*yield*/, this._authRenewal()];
                    case 4:
                        _a.sent();
                        return [4 /*yield*/, this.reactivateFilmTester(email, campaignId, false)];
                    case 5:
                        tester = _a.sent();
                        return [2 /*return*/, tester];
                    case 6: throw new errors_1.PermissionError('Invalid access token');
                    case 7: return [3 /*break*/, 9];
                    case 8:
                        error_34 = _a.sent();
                        logger.error('Error reactivateFilmTester', { msg: error_34.message, name: error_34.name });
                        throw new Error(error_34.message);
                    case 9: return [2 /*return*/];
                }
            });
        });
    };
    ;
    /**
     * Returns a list of testers of a campaign
     *
     * @param {string} campaignId The campaign identifier
     *
     * @returns {Promise<TesterItem[]>} The tester item updated
     *
     * @throws {PermissionError} Auth token not valid
     */
    CampaignAccess.prototype.getTestersByCampaignId = function (campaignId, renew) {
        if (renew === void 0) { renew = true; }
        return __awaiter(this, void 0, void 0, function () {
            var res, tester, tester, error_35;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 8, , 9]);
                        return [4 /*yield*/, this.api.getTestersByCampaignId(campaignId)];
                    case 1:
                        res = _a.sent();
                        if (!(res.status === 200)) return [3 /*break*/, 3];
                        return [4 /*yield*/, res.json()];
                    case 2:
                        tester = _a.sent();
                        logger.debug('getTestersByCampaignId updated', __assign({}, tester));
                        return [2 /*return*/, tester];
                    case 3:
                        if (!(res.status === 403 && renew)) return [3 /*break*/, 6];
                        return [4 /*yield*/, this._authRenewal()];
                    case 4:
                        _a.sent();
                        return [4 /*yield*/, this.getTestersByCampaignId(campaignId, false)];
                    case 5:
                        tester = _a.sent();
                        return [2 /*return*/, tester];
                    case 6: throw new errors_1.PermissionError('Invalid access token');
                    case 7: return [3 /*break*/, 9];
                    case 8:
                        error_35 = _a.sent();
                        logger.error('Error getTestersByCampaignId', { msg: error_35.message, name: error_35.name });
                        throw new Error(error_35.message);
                    case 9: return [2 /*return*/];
                }
            });
        });
    };
    ;
    /**
     * Returns a list of features of a campaign
     *
     * @throws {PermissionError} Auth token not valid
     */
    CampaignAccess.prototype.getCampaignFeatures = function (renew) {
        if (renew === void 0) { renew = true; }
        return __awaiter(this, void 0, void 0, function () {
            var res, tester, tester, error_36;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 8, , 9]);
                        return [4 /*yield*/, this.api.getCampaignFeatures()];
                    case 1:
                        res = _a.sent();
                        if (!(res.status === 200)) return [3 /*break*/, 3];
                        return [4 /*yield*/, res.json()];
                    case 2:
                        tester = _a.sent();
                        logger.debug('getCampaignFeatures updated', __assign({}, tester));
                        return [2 /*return*/, tester];
                    case 3:
                        if (!(res.status === 403 && renew)) return [3 /*break*/, 6];
                        return [4 /*yield*/, this._authRenewal()];
                    case 4:
                        _a.sent();
                        return [4 /*yield*/, this.getCampaignFeatures(false)];
                    case 5:
                        tester = _a.sent();
                        return [2 /*return*/, tester];
                    case 6: throw new errors_1.PermissionError('Invalid access token');
                    case 7: return [3 /*break*/, 9];
                    case 8:
                        error_36 = _a.sent();
                        logger.error('Error getCampaignFeatures', { msg: error_36.message, name: error_36.name });
                        throw new Error(error_36.message);
                    case 9: return [2 /*return*/];
                }
            });
        });
    };
    ;
    /**
     * Updates the campaign chosen audience type
     *
     * @param {string} campaignId The campaign identifier
     * @param {string} chosenAudienceType The chosen audience type
     *
     * @returns {Promise<CampaignVersion>} The CampaignVersion  object
     */
    CampaignAccess.prototype.updateChosenAudienceType = function (campaignId, chosenAudienceType, renew) {
        if (renew === void 0) { renew = true; }
        return __awaiter(this, void 0, void 0, function () {
            var res, updatedCampaignVersion, updatedCampaignVersion, error_37;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 8, , 9]);
                        return [4 /*yield*/, this.api.updateChosenAudienceType(campaignId, chosenAudienceType)];
                    case 1:
                        res = _a.sent();
                        if (!(res.status === 200)) return [3 /*break*/, 3];
                        return [4 /*yield*/, res.json()];
                    case 2:
                        updatedCampaignVersion = _a.sent();
                        logger.debug('CampaignVersion updated', __assign({}, updatedCampaignVersion));
                        return [2 /*return*/, updatedCampaignVersion];
                    case 3:
                        if (!(res.status === 403 && renew)) return [3 /*break*/, 6];
                        return [4 /*yield*/, this._authRenewal()];
                    case 4:
                        _a.sent();
                        return [4 /*yield*/, this.updateChosenAudienceType(campaignId, chosenAudienceType, false)];
                    case 5:
                        updatedCampaignVersion = _a.sent();
                        return [2 /*return*/, updatedCampaignVersion];
                    case 6: throw new errors_1.PermissionError('Invalid access token');
                    case 7: return [3 /*break*/, 9];
                    case 8:
                        error_37 = _a.sent();
                        logger.error('Error updateChosenAudienceType', { msg: error_37.message, name: error_37.name });
                        throw new Error(error_37.message);
                    case 9: return [2 /*return*/];
                }
            });
        });
    };
    ;
    /**
     * Updates the campaign features
     *
     * @param {string} campaignId The campaign identifier
     * @param {string} features The features
     *
     * @returns {Promise<CampaignItem>} The CampaignVersion  object
     */
    CampaignAccess.prototype.updateCampaignFeatures = function (campaignId, features, renew) {
        if (renew === void 0) { renew = true; }
        return __awaiter(this, void 0, void 0, function () {
            var res, updatedCampaignVersion, updatedCampaignVersion, error_38;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 8, , 9]);
                        return [4 /*yield*/, this.api.updateCampaignFeatures(campaignId, features)];
                    case 1:
                        res = _a.sent();
                        if (!(res.status === 200)) return [3 /*break*/, 3];
                        return [4 /*yield*/, res.json()];
                    case 2:
                        updatedCampaignVersion = _a.sent();
                        logger.debug('CampaignVersion updated', __assign({}, updatedCampaignVersion));
                        return [2 /*return*/, updatedCampaignVersion];
                    case 3:
                        if (!(res.status === 403 && renew)) return [3 /*break*/, 6];
                        return [4 /*yield*/, this._authRenewal()];
                    case 4:
                        _a.sent();
                        return [4 /*yield*/, this.updateCampaignFeatures(campaignId, features, false)];
                    case 5:
                        updatedCampaignVersion = _a.sent();
                        return [2 /*return*/, updatedCampaignVersion];
                    case 6: throw new errors_1.PermissionError('Invalid access token');
                    case 7: return [3 /*break*/, 9];
                    case 8:
                        error_38 = _a.sent();
                        logger.error('Error updateCampaignFeatures', { msg: error_38.message, name: error_38.name });
                        throw new Error(error_38.message);
                    case 9: return [2 /*return*/];
                }
            });
        });
    };
    ;
    /**
     * Publish campaign without paying
     *
     * @param {string} campaignId campaignId.
     *
     */
    CampaignAccess.prototype.publishCampaign = function (campaignId, renew) {
        if (renew === void 0) { renew = true; }
        return __awaiter(this, void 0, void 0, function () {
            var res, result, res_2, e, error_39;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 10, , 11]);
                        return [4 /*yield*/, this.api.publishCampaign(campaignId)];
                    case 1:
                        res = _a.sent();
                        if (!res.ok) return [3 /*break*/, 3];
                        return [4 /*yield*/, res.json()];
                    case 2:
                        result = _a.sent();
                        logger.debug('publishCampaign from API', __assign({}, result));
                        return [2 /*return*/, result];
                    case 3:
                        if (!(res.status === 403 && renew)) return [3 /*break*/, 6];
                        return [4 /*yield*/, this._authRenewal()];
                    case 4:
                        _a.sent();
                        return [4 /*yield*/, this.publishCampaign(campaignId, false)];
                    case 5:
                        res_2 = _a.sent();
                        return [2 /*return*/, res_2];
                    case 6:
                        if (!(res.status === 400)) return [3 /*break*/, 8];
                        return [4 /*yield*/, res.json()];
                    case 7:
                        e = _a.sent();
                        logger.error('publishCampaign status 400', { e: e });
                        throw new errors_1.NotFoundError(e.message);
                    case 8: throw new errors_1.PermissionError('Invalid access token');
                    case 9: return [3 /*break*/, 11];
                    case 10:
                        error_39 = _a.sent();
                        logger.error('Error publishCampaign', { msg: error_39.message, name: error_39.name });
                        throw new Error(error_39.message);
                    case 11: return [2 /*return*/];
                }
            });
        });
    };
    return CampaignAccess;
}());
;
exports.default = CampaignAccess;
//# sourceMappingURL=CampaignAccess.js.map